import { h } from 'preact';
export const Music = (props) => {
    const color = props.color || 'currentColor';
    const size = props.size || 24;
    delete props.color;
    delete props.size;
    return (h("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: size, height: size, viewBox: "0 0 24 24", fill: "none", stroke: color, "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round" }, props),
        h("path", { d: "M9 18V5l12-2v13" }),
        h("circle", { cx: "6", cy: "18", r: "3" }),
        h("circle", { cx: "18", cy: "16", r: "3" })));
};
//# sourceMappingURL=music.js.map